/**
 * WebGPU debug labels env toggle.
 *
 * Mirrors the in-page toggles documented in
 * `layers/game/app/utils/webgpu-debug-labels.ts` (`?debug=labels` query,
 * `localStorage.__labelDebug='1'`, `window.__labelDebug=true`) by also
 * accepting an env-driven flag from `runtimeConfig.public.webgpuDebugLabels`
 * (set via `NUXT_PUBLIC_WEBGPU_DEBUG_LABELS=true`).
 *
 * Set `window.__labelDebug = true` BEFORE any component mounts so that the
 * `wrapWebGPUDeviceForDebug()` call at PIXI app init time sees the flag and
 * actually wraps the device. `enforce: 'pre'` plus the lack of `parallel`
 * guarantees we land before CrashGraph / useCashoutRunners / PetViewer /
 * CharacterViewer / OreRefineModal create their renderers.
 *
 * No-op on SSR (the labeler is client-only).
 */

export default defineNuxtPlugin({
  name: 'webgpu-debug-labels-env',
  enforce: 'pre',
  setup() {
    if (typeof window === 'undefined') return
    const cfg = useRuntimeConfig()
    if (cfg.public.webgpuDebugLabels === true) {
      ;(window as Window & { __labelDebug?: boolean }).__labelDebug = true
    }
  },
})
